import React from "react";
import Gallery from "./Gallery";
import "./styles/App.css";

function Art() {
  return (
    <div className="App">
      <div className="Main">
        <Gallery />
      </div>
    </div>
  );
}

export default Art;
